import { PermissionCode } from '@gb-ticket/shared-types';
import { useVoiceCopy } from '@/platform/voice/use-voice';

import { hasPermission } from '@/features/auth/permissions';
import { useMe } from '@/features/auth/use-me';
import { TicketCreateForm } from '@/products/helpdesk/features/tickets/ticket-create-form';
import { usePageTitle } from '@/hooks/use-page-title';

export function TicketCreatePage() {
  const copy = useVoiceCopy();
  usePageTitle('Neues Ticket');
  const me = useMe();
  if (!hasPermission(me.data, PermissionCode.TICKETS_CREATE)) {
    return (
      <section className="mx-auto max-w-md space-y-3 text-center">
        <h1 className="text-2xl font-bold">Kein Zugriff</h1>
        <p className="text-muted-foreground">{copy('helpdesk.ticket.create.forbidden')}</p>
      </section>
    );
  }
  return <TicketCreateForm />;
}
